import {
  CLEAR_FETCH_CONTACTS_FOR_EVENT,
  FETCH_CONTACTS_FOR_EVENT_FAILURE,
  FETCH_CONTACTS_FOR_EVENT_SUCCESS,
  REQUEST_FETCH_CONTACTS_FOR_EVENT,
} from "./contact.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loadiing: false,
};

const contactsEmReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_CONTACTS_FOR_EVENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CONTACTS_FOR_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };
    case FETCH_CONTACTS_FOR_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };
    case CLEAR_FETCH_CONTACTS_FOR_EVENT:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };
    default:
      return state;
  }
};

export default contactsEmReducer;
